<div id="main" class="col-xs-12">
  <app-breadcrumb currentPage="Simulador" routerCurrentPage="/simulador"></app-breadcrumb>

  <div id="simulador" class="row">
    <div class="container-fluid">
      <div class="row">
        <div class="hidden-xs hidden-sm col-md-1"></div>
        <div class="col-md-11 justify-content-left">
          <h3 style="margin-top: -10px; margin-bottom: 20px; padding-left: 30px">Simulador</h3>
        </div>
      </div>
      <div class="row" style="padding-bottom:10px">
        <div class="hidden-xs hidden-sm col-md-1"></div>
        <div class="col-sm-12 col-md-5">
          <div [formGroup]="simulationForm" class="row forms">
            <div class="form-group w-95">
              <span class="icon car-simulator"></span>
              <div class="inputs">
                <label for="products">Produto</label>
                <select
                    name="products"
                    class="form-control"
                    formControlName="product"
                    required
                    appShowErrorMessages
                    requiredMessage="O campo Produto é obrigatório">
                  <option value="" selected hidden>Selecione...</option>
                  <option value="Produto 1">Produto 1</option>
                  <option value="Produto 2">Produto 2</option>
                  <option value="Produto 3">Produto 3</option>
                </select>
              </div>
            </div>

            <div class="form-group w-95">
              <span class="icon product-year"></span>
              <div class="inputs">
                <label for="product-year">Ano Produto</label>
                <select name="product-year" class="form-control" formControlName="productYear" required>
                  <option value="" selected hidden>Selecione...</option>
                  <option *ngFor="let ele of yearArray" [value]="ele">{{ele}}</option>
                </select>
              </div>
            </div>

            <div class="form-group w-95">
              <span class="icon deadline"></span>
              <div class="inputs">
                <label for="deadlineOne">Prazo</label>
                <select name="deadlineOne" class="form-control" formControlName="deadline" required>
                  <option value="" selected hidden>Selecione...</option>
                  <option *ngFor="let ele of deadlineArray" [value]="ele">{{ele}} parcelas</option>
                </select>
              </div>
            </div>

            <div class="form-group w-95">
              <span class="icon return"></span>
              <div class="inputs">
                <label for="return" style="padding-bottom: 10px">Retorno</label>
                <app-slider (outputEmitter)="handleSliderChange($event)"></app-slider>
              </div>
            </div>

            <div class="form-group w-95">
              <span class="icon term"></span>
              <div class="inputs">
                <label for="deadlineTwo">Vencimento 1ª Parcela</label>
                <input
                    class="form-control"
                    placeholder="00/00/0000"
                    type="text"
                    name="deadlineTwo"
                    formControlName="firstParcelDeadline"
                required>
              </div>
            </div>

            <div class="form-group w-95">
              <span class="icon money-bill"></span>
              <div class="inputs">
                <label for="value">Valor Financiado</label>
                <input
                    appOnlyMoney
                    mask-money
                    [prefix]="'R$'"
                    placeholder="R$ 999.999,99"
                    maxlength=14
                    class="form-control"
                    type="text"
                    name="value"
                    formControlName="financedValue"
                required>
              </div>
            </div>

            <div class="pull-right">
              <a
                  class="bt-go btn btn-full-orange"
                  [ngClass]="{'disabled': !simulationForm.valid}"
                  (click)="onClickSimulate()"
                  style="margin: 0 25px 20px 0">
                Simular Financiamento
              </a>
            </div>
          </div>
        </div>

        <div class="col-sm-12 col-md-5">
          <div class="inputs simulation-output blue-box">
            <p><small>Valor da prestação</small></p>
            <p class="simulation-value" *ngIf="!isSimulated"></p>
            <p class="simulation-value" *ngIf="isSimulated">{{ terms }}x {{ termValue | currency:'BRL':'symbol' }}</p>
            <p><small>Validade desta simulação</small></p>
            <p class="simulation-value" *ngIf="!isSimulated"></p>
            <p class="simulation-value" *ngIf="isSimulated">{{ simulationDate }}</p>
            <p><small>Sujeito à Simulação</small></p>
            <p class="simulation-value" >---</p>
          </div>
        </div>
        <div class="hidden-xs hidden-sm col-md-1"></div>
      </div>
    </div>
  </div>
</div>
